/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   Developer: Aashish Singh, Created Date: 04-July-2025
</summary>
*/
enum TerminationTypeEnum{
    None = 0,
    Abort = 1,
    ScheduleDurationDaysOver = 2,
    DeviceFailToUpdateFirmwareSegment=3
}

export default TerminationTypeEnum;